import { render, staticRenderFns } from "./SearchMultiLabelsBody.vue?vue&type=template&id=03fda432&scoped=true"
import script from "./SearchMultiLabelsBody.vue?vue&type=script&lang=js"
export * from "./SearchMultiLabelsBody.vue?vue&type=script&lang=js"
import style0 from "./SearchMultiLabelsBody.vue?vue&type=style&index=0&id=03fda432&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fda432",
  null
  
)

export default component.exports